export class Terminal {
  id: number = null;
  name: string = '';
  password: string = '';
  lastTerminalCheckIn: string = '';
  hasPassword: boolean = false;
  selectLanguage: boolean = false;
  languageId: number = null;
  skipLanguageSelection: boolean = false;
  simpleView: boolean = false;

  constructor(config?: Partial<Terminal>) {
    if (config) {
      Object.keys(config)
        .filter(key => typeof config[key] !== 'undefined')
        .forEach(key => this[key] = config[key]);
    }
  }
}
